export const SERVICE_LOADING = 'SERVICE_LOADING';
export const GET_SERVICES = 'GET_SERVICES';
export const FEATURE_LOADING = 'FEATURE_LOADING';
export const GET_FEATURES = 'GET_FEATURES';
export const TYPE_SERVICE_LOADING = 'TYPE_SERVICE_LOADING';
export const GET_TYPE_SERVICE = 'GET_TYPE_SERVICE';
export const GET_SERVICES_COMBO = 'GET_SERVICES_COMBO';
export const GET_SERVICES_MANUAL_LICENSE_COMBO = 'GET_SERVICES_MANUAL_LICENSE_COMBO';
